import '../windows/style.css';
import React, { useContext, useEffect, useState, useMemo } from 'react';
import DashLayout from '../../layout/DashLayout';
import { useProfileData } from '../../NecttosComp/APICaller/queryHooks';
import { FirebaseContext } from '../../context/FirebaseContext';
import { checkRoles, usePersistentState, validateRole } from '../../utils';
import Cookies from 'js-cookie';
import { WindowRenderer, getMenuList } from '../windows/MenuList';
import { FullScreenContext } from '../../context/FullScreenContext';
import { icons } from '../windows/Icons';
import { ProgressBar } from '../../NecttosComp/ProgressBar/ProgressBar';
import { useTheme } from '../../context/ThemeContext.js.js';
import StaticstcsPieChart from '../../components/Graph/PieChart';
import { Bar, BarChart, CartesianGrid, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CollegeLogoSettingsSvg, ProfileSettingsSvg, SearchIconSvg } from '../../static/svg/icons';
import Logo from '../../static/home/logotr.png';
import { ROLES } from '../../config/constants';
import { NecttosContext } from '../../context/NecttosContext';

function SecondaryDashboard() {
	const { data } = useProfileData();
	const { collegeId, college, isLoading, profile, selectedCollege, role } = useContext(NecttosContext);
		const verificationWindows = college?.verificationWindows;

	const MENU_ITEMS = useMemo(() => getMenuList(collegeId, verificationWindows, selectedCollege, role), [collegeId, verificationWindows, selectedCollege, role]);

	const [classification, setClassification] = useState('All');
	const { isFullScreen, togleFullScreen } = useContext(FullScreenContext);
	const [sidebarWidth, setSidebarWidth] = useState(40);
	const { theme, toggleTheme } = useTheme();


	const [criteria, setCriteria] = usePersistentState('homePage', {});
	const [windows, setWindows] = usePersistentState('homePage', {
		issueBook: false,
		renewBook: false,
		returnBook: false,
		opac: false,
		master: false,
		questionBankCreator: false,
	});

	useEffect(() => {
		const appWindow = document.querySelector('.app-window');
		if (appWindow) {
			appWindow.classList.add('open');
		}
	}, []);

	const handleLogout = () => {
		localStorage.clear();
		Cookies.remove('userToken');
		window.location.href = '/';
		window.location.reload(true);
	};

	const getPrimaryRoles = (roles) => roles?.filter((role) => ROLES.includes(role)) || [];
	const getSecondaryRoles = (roles) => roles?.filter((role) => !ROLES.includes(role)) || [];

	const [searchQuery, setSearchQuery] = useState('');

	const searchData = useMemo(() => {
		return MENU_ITEMS?.filter((item) => item.title.toLowerCase().includes(searchQuery.toLowerCase()));
	}, [searchQuery, MENU_ITEMS]);

	const ICON_BACKGROUNDS = [
		'#20A0D1', // Sky Blue
		'#00A482', // Teal
		'#0676DA', // Royal Blue
		'#6471D9', // Indigo
		'#F0635C', // Coral Red
		'#FFB347', // Soft Orange
		'#7E57C2', // Purple
		'#26A69A', // Aqua
		'#FF7043', // Orange Accent
		'#5C6BC0', // Slate Blue
	];

	const ICON_BACKGROUNDS_DARK = [
		'#104E65', // Dark Sky Blue
		'#005B4A', // Dark Teal
		'#03407F', // Deep Royal Blue
		'#3C3F80', // Deep Indigo
		'#7A312C', // Dark Coral Red
		'#B2742E', // Burnt Orange
		'#45277A', // Deep Purple
		'#145E59', // Deep Aqua
		'#A1361D', // Deep Orange
		'#39449A', // Dark Slate Blue
	];

	const memoizedSearchResults = useMemo(() => {
		return searchData?.reduce((acc, item, index) => {
			const isValidRole = checkRoles(item.allowedUsers, role, collegeId);
			const isMatchingClassification = classification === 'All' ? true : item.classification === classification;
			const isNotNAAC = !['c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7'].includes(item.classification.toLowerCase());

			if ((searchQuery && isValidRole) || (isValidRole && isMatchingClassification && isNotNAAC)) {
				const bgColor = theme === 'dark' ? ICON_BACKGROUNDS_DARK[index % ICON_BACKGROUNDS_DARK.length] : ICON_BACKGROUNDS[index % ICON_BACKGROUNDS.length];

				acc.push(
					<div className='roleCards float-left' key={item?.keyData + item.classification}>
						<div id={item?.keyData + item.classification} className='w-full flex flex-col items-center space-y-2'>
							<div onClick={() => setWindows({ [item?.keyData]: true })} className='w-20 h-20 sm:w-24 sm:h-24 rounded-2xl flex items-center justify-center cursor-pointer transition-transform duration-300 shadow-lg hover:scale-105' style={{ backgroundColor: bgColor }}>
								<img src={icons[item.keyData] || item?.img} alt={item?.title} className='w-10 h-10 sm:w-12 sm:h-12 object-contain' />
							</div>
						</div>
						<div className='w-full flex justify-center mt-2'>
							<h2 className='text-white  text-center text-sm sm:text-base font-semibold leading-snug break-words'>{item?.title}</h2>
						</div>
					</div>,
				);
			}
			return acc;
		}, []);
	}, [searchData, role, collegeId, classification, searchQuery]);

	return (
		<DashLayout>
			<div className={`w-[100%] h-[100vh] flex from-[#0099FF] to-[#004AAD] dark:from-[#3F88E5] dark:to-[#102B5E] bg-gradient-to-br align-middle justify-center`}>
				<div className='w-[100%] h-[95vh] flex  flex-row m-3  bg-[#016DC9] rounded-[1em]  dark:from-[#2A70C3] dark:to-[#1C5298] dark:bg-gradient-to-br '>
					<div className={'w-[80%] h-[95vh] flex rounded-4xl flex-col overflow-scroll'}>
						<div
							className='absolute w-[70%] opacity-15'
							style={{
								backgroundImage: `url(${Logo})`,
								backgroundPosition: 'center',
								backgroundRepeat: 'no-repeat',
								backgroundSize: '50vh',
								pointerEvents: 'none',
							}}
						/>
						<div className='flex flex-col bg-[rgba(148,201,255,0.15)]  dark:to-[#1c5298d2] dark:from-[#1c5298c8] dark:bg-gradient-to-br rounded-[1em] p-4 m-2 mt-2 pb-1  shadow'>
							<div className={'w-[100%] h-[100%] flex flex-row rounded justify-between'}>
								<div className='w-[60%]'>
									<div className='text-4xl font-bold bg-gradient-to-r to-[#55b1eee2] from-[#ffffff] bg-clip-text text-transparent'>Welcome, {profile?.name}.</div>
									<h5 className='text-[#FFFFFF] text-[13px]'>{selectedCollege?.collegeName || 'College  Name'}</h5>
									<div>
										<div className='text-[15px] font-bold bg-gradient-to-r to-[#0099FF] from-[#FFFFFF] bg-clip-text text-transparent'>Powered by Necttos Limited.</div>
									</div>
									<p className='text-[#FFFFFF] text-[10px]'>A public limited company dedicated to reducing clerical work in educational institutions, allowing more focus on research and teaching.</p>
									<div className='text-[#0099FF] p-1 w-full'></div>

									<div>
										<div className='mb-0 mt-0 text-2xl font-bold bg-gradient-to-r from-[#0099FF] to-[#FFFFFF] bg-clip-text text-transparent'>Self-Description</div>
										<p className='text-white mb-2'>
											Primary:{' '}
											{getPrimaryRoles(role).map((role, index) => (
												<span key={index} className='inline-block px-2 py-1 mr-2 bg-blue-500 bg-opacity-20 rounded'>
													{role}
												</span>
											))}
										</p>
										<p className='text-white'>
											Secondary:{' '}
											{getSecondaryRoles(role).map((role, index) => (
												<span key={index} className='inline-block px-2 py-1 mr-2 bg-blue-400 bg-opacity-20 rounded'>
													{role}
												</span>
											))}
										</p>
									</div>
								</div>
								<ProfileSection data={data} selectedCollege={selectedCollege} />
							</div>
							<div className='w-full h-[2px] bg-slate-400 mt-1'></div>

							<div className='flex flex-row justify-between w-[100%] mt-2 hover:cursor-pointer'>
								<div className='flex flex-row justify-between w-[50%] align-middle items-center'>
									<p onClick={togleFullScreen} className='text-white m-0'>
										{!isFullScreen ? 'Full screen' : 'Exit Full Screen'}
									</p>
									<div className='flex flex-row justify-between items-center'>
										<p className='text-white m-0 '>Dark Theme</p>
										<div className={`ml-2 relative inline-block w-12 h-6 transition-colors duration-300 rounded-full ${theme === 'dark' ? 'bg-blue-600' : 'bg-gray-300'}`} onClick={toggleTheme} role='switch' aria-checked={theme === 'dark'} aria-label='Toggle Dark Theme'>
											<span className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ease-in-out ${theme === 'dark' ? 'transform translate-x-6' : ''}`} />
										</div>
									</div>

									<p className='text-white m-0'>To-do list</p>
									<p className='text-white m-0' onClick={() => setWindows({ newProfile: true })}>
										Profile
									</p>
									<p className='text-white m-0'>Support</p>
									<p onClick={()=>setWindows({settings:true})} className='text-white m-0'>Settings</p>
								</div>
								<div>
									<p className='text-white  m-2' onClick={handleLogout}>
										Logout
									</p>
								</div>
							</div>
						</div>
						<div className='flex flex-col rounded-e-3xl align-middle justify-between m-2 mt-0'>
							<div className='grid grid-cols-[2fr_2fr_1fr] gap-2'>
								<div>
									<StaticstcsPieChart
										data={[
											{ value: 200, color: '#FD76FF', name: 'Total girls' },
											{ value: 300, color: '#0099FF', name: 'Total boys' },
											{ value: 10, color: '#4444', name: 'Others' },
										]}
										title={'Gender Ratio'}
										first
									/>
								</div>

								<div>
									<StaticstcsPieChart
										data={[
											{ value: 13, color: '#375376', name: 'E-Grantz' },
											{ value: 90, color: '#033066', name: 'Pre/post Metrics' },
											{ value: 40, color: '#666666', name: 'Fisheries E-Grantz' },
										]}
										title={'Scholarship Ratio'}
										first
									/>
								</div>

								<div>
									<StudentsFrom
										data={[
											{ place: 'Thiruvananthapuram', count: 120 },
											{ place: 'Kollam', count: 110 },
											{ place: 'Pathanamthitta', count: 95 },
											{ place: 'Alappuzha', count: 105 },
											{ place: 'Kottayam', count: 115 },
											{ place: 'Idukki', count: 90 },
											{ place: 'Ernakulam', count: 130 },
											{ place: 'Thrissur', count: 140 },
											{ place: 'Palakkad', count: 125 },
											{ place: 'Malappuram', count: 150 },
											{ place: 'Kozhikode', count: 160 },
											{ place: 'Wayanad', count: 85 },
											{ place: 'Kannur', count: 110 },
											{ place: 'Kasaragod', count: 95 },
										]}
									/>
								</div>
							</div>

							<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1'>
								<StaticstcsPieChart
									data={[
										{ value: 10, color: '#90BE6D', name: 'Present' },
										{ value: 13, color: '#F9C74F', name: 'Absend' },
									]}
									title={'Attendance'}
								/>
								<StaticstcsPieChart
									data={[
										{ value: 45, color: '#7209B7', name: 'Day-scholar' },
										{ value: 25, color: '#4361EE', name: 'Hostel' },
										{ value: 15, color: '#4CC9F0', name: 'PG' },
										{ value: 15, color: '#F72585', name: 'With relatives' },
									]}
									title={'Housing'}
								/>
								<StaticstcsPieChart
									data={[
										{ value: 40, color: '#4361EE', name: 'Both parents' },
										{ value: 15, color: '#7209B7', name: 'Father only' },
										{ value: 20, color: '#4CC9F0', name: 'Mother only' },
										{ value: 10, color: '#F72585', name: 'With siblings' },
										{ value: 15, color: '#3A0CA3', name: 'Living alone' },
									]}
									title={'Family Background'}
								/>
							</div>

							<StudentsStatistics
								years={[
									{
										year: '2021',
										totalAdmimission: 1200,
										nominalRoles: 1150, // ~95% of admissions
										couseCompleted: 1050, // ~90% of nominal
										passOut: 980, // ~93% of completed
									},
									{
										year: '2022',
										totalAdmimission: 1250,
										nominalRoles: 1200, // ~96% of admissions
										couseCompleted: 1100, // ~92% of nominal
										passOut: 1050, // ~95% of completed
									},
									{
										year: '2023',
										totalAdmimission: 1300,
										nominalRoles: 1260, // ~97% of admissions
										couseCompleted: 1180, // ~94% of nominal
										passOut: 1150, // ~97% of completed
									},
									{
										year: '2024',
										totalAdmimission: 1350,
										nominalRoles: 1320, // ~98% of admissions
										couseCompleted: 1250, // ~95% of nominal
										passOut: 1200, // ~96% of completed
									},
									{
										year: '2025',
										totalAdmimission: 1400,
										nominalRoles: 1380, // ~99% of admissions
										couseCompleted: 1300, // ~94% of nominal
										passOut: 1250, // Current year, no passouts yet
									},
								]}
							/>
						</div>
					</div>
					<div
						className={`bg-[#1778cced] rounded-r-lg   dark:to-[#1c5298d2] dark:from-[#1c5298c8] dark:bg-gradient-to-br r-0 `}
						style={{
							width: `${sidebarWidth}%`,
							minWidth: '20%',
							maxWidth: '80%',
							position: 'relative',
						}}>
						<div
							className='absolute left-0 top-0 w-1 h-full cursor-ew-resize hover:bg-blue-500'
							onMouseDown={(e) => {
								const startX = e.pageX;
								const startWidth = sidebarWidth;

								const handleMouseMove = (e) => {
									const delta = e.pageX - startX;
									const newWidth = Math.min(80, Math.max(20, startWidth - (delta / window.innerWidth) * 100));
									setSidebarWidth(newWidth);
								};

								const handleMouseUp = () => {
									document.removeEventListener('mousemove', handleMouseMove);
									document.removeEventListener('mouseup', handleMouseUp);
								};

								document.addEventListener('mousemove', handleMouseMove);
								document.addEventListener('mouseup', handleMouseUp);
							}}
						/>
						<div style={{ width: '100%', height: '100%', position: 'relative' }}>
							<div className='flex m-2 w-[97%] h-10  items-center bg-[#004badb7] dark:bg-[#102a5dbf] rounded-xl justify-center content-center align-middle p-2'>
								<SearchIconSvg styles={{ height: 20, width: 20, fill: '#fff' }} />
								<input className={`w-full h-9 font-bold text-white outline-none border-none placeholder:text-white placeholder:text-opacity-50 m-0 active:bg-transparent ${searchQuery ? 'bg-transparent text-black' : 'bg-transparent'}`} placeholder='Search' id='search' type='search' onChange={(e) => setSearchQuery(e.target.value)} value={searchQuery} />
							</div>

							<div className='flex flex-row overflow-x-scroll'>
								{['All', 'Office', 'Accademics', 'Accounts', 'FYUGP', 'Library', 'DDFS', 'Adminitration', 'NAAC', 'IQAC'].map((role, index) => (
									<div
										key={index}
										className={`text-white m-1 p-2 rounded-xl cursor-pointer`}
										onClick={() => {
											setClassification(role);
										}}>
										{role}
										{classification === role && <span className='text-white text-xs ml-1 absolute w-full bg-white'></span>}
									</div>
								))}
							</div>

							<div className='w-[100%] flex justify-center pb-5 h-full mt-3 overflow-hidden '>
								<div className='components h-[90%] grid-auto justify-between flex flex-wrap overflow-y-scroll'>{memoizedSearchResults}</div>
							</div>
						</div>
					</div>
				</div>
				<WindowRenderer windows={windows} setWindows={setWindows} criteria={criteria} setCriteria={setCriteria} verificationWindows={verificationWindows} />
			</div>
		</DashLayout>
	);
}

const StudentsFrom = ({ data }) => {
	const totalCount = data.reduce((acc, curr) => acc + curr.count, 0);
	const percentageData = data
		.map((item) => ({
			...item,
			percentage: ((item.count / totalCount) * 100).toFixed(2),
		}))
		.sort((a, b) => b.percentage - a.percentage);

	return (
		<div
			className={`
		  flex rounded-2xl mt-1 shadow-md 
		  bg-[#1777CC] flex-col justify-start p-4
		  dark:to-[#1c5298d2] dark:from-[#1c5298c8] 
		  dark:bg-gradient-to-br overflow-y-auto
		`}
			style={{
				width: '100%',
				height: '400px', // Match height with PieChart
			}}>
			<h6 className='text-white text-lg mb-4'>Most students from</h6>
			<div className='flex flex-col gap-2 overflow-y-auto'>
				{percentageData?.map((item, index) => (
					<div key={index} className='flex flex-col w-full'>
						<span className='text-sm text-white mb-1'>{item.place}</span>
						<div className='flex items-center'>
							<div className='flex bg-[#002267] w-full rounded-full h-2'>
								<div
									className='bg-[#00ff37] rounded-full'
									style={{
										width: `${item.percentage}%`,
										height: '100%',
									}}></div>
							</div>

							<span className='text-sm text-white ml-2'>{item.percentage}</span>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

const StudentsStatistics = ({ years }) => {
	return (
		<div className='w-[99%] p-3 m-2 flex justify-center content-center flex-col rounded bg-[rgba(148,201,255,0.15)]  dark:to-[#1c5298d2] dark:from-[#1c5298c8] dark:bg-gradient-to-br'>
			<h3 className='text-center text-white'>Student Enrolement Statics</h3>
			<div className='flex flex-row w-[100%]'>
				<div className='flex justify-center content-center w-[100%] h-[40vh] overflow-x-scroll'>
					<ResponsiveContainer width='100%' height='100%'>
						<BarChart width={500} height={300} data={years} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
							<CartesianGrid strokeDasharray='2 3' stroke='rgba(255,255,255,0.2)' />
							<XAxis dataKey='year' width={'200px'} stroke='#fff' tick={{ fill: '#fff' }} />
							<YAxis stroke='#fff' tick={{ fill: '#fff' }} />
							<Tooltip
								contentStyle={{
									backgroundColor: 'rgba(0,0,0,0.8)',
									border: 'none',
									borderRadius: '4px',
									color: '#fff',
								}}
								labelStyle={{ color: '#fff' }}
							/>
							<Bar dataKey='totalAdmimission' fill='#170bffb8' activeBar={<Rectangle fill='#170bffb8' stroke='#4C8FFF' />} />
							<Bar dataKey='nominalRoles' fill='#00d5ffda' activeBar={<Rectangle fill='#00d5ffda' stroke='#7F8C8D' />} />
							<Bar dataKey='couseCompleted' fill='#00ffd0da' activeBar={<Rectangle fill='#00ffd0da' stroke='#2ECC71' />} />
							<Bar dataKey='passOut' fill='#0fff4bc9' activeBar={<Rectangle fill='#0fff4bc9' stroke='#F39C12' />} />
						</BarChart>
					</ResponsiveContainer>
				</div>
				<div className='flex justify-center content-center w-[30%] flex-col text-white'>
					<div className='flex justify-between text-white items-center'>
						<span className='w-[15%] h-[30%] bg-[#170bffb8] m-2'></span>
						<div className='w-full m-2 '>
							<p className=' text-white'>Total admission</p>
						</div>
					</div>
					<div className='flex justify-between '>
						<span className='w-[15%] h-[30%] bg-[#00d5ffda] items-center m-2'></span>
						<div className='w-full m-2'>
							<p className=' text-white'>Nominal roll</p>
						</div>
					</div>
					<div className='flex justify-between'>
						<span className='w-[15%] h-[30%] bg-[#00ffd0da] items-center m-2'></span>
						<div className='w-full m-2'>
							<p className=' text-white'>Course Completed</p>
						</div>
					</div>
					<div className='flex justify-between'>
						<span className='w-[15%] h-[30%] bg-[#0fff4bc9] items-center m-2'></span>
						<div className='w-full m-2'>
							<p className=' text-white'>Pass Out</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const ProfileSection = ({ data, selectedCollege }) => {
	return (
		<div className='w-[20%] flex flex-col'>
			<div className='relative h-48'>
				{/* Profile Image with Spinning Border */}
				<div className='absolute right-[5em] top-8 flex items-center justify-center'>
					<div className='animate-spin-slow'>
						<ProfileSettingsSvg
							styles={{
								height: 140,
								width: 140,
								filter: 'drop-shadow(0 0 10px rgba(85, 177, 238, 0.3))',
							}}
						/>
					</div>
					<img
						src={data?.photoURL}
						alt='Profile'
						className='absolute top-5 h-[100px] w-[100px] rounded-full 
						 object-cover border-2 border-blue-400 
						 shadow-lg transition-transform hover:scale-105'
					/>
				</div>

				{/* College Logo with Reverse Spinning Border */}
				<div className='absolute right-1 top-0 flex items-center justify-center'>
					<div className='animate-spin-reverse-medium'>
						<CollegeLogoSettingsSvg
							styles={{
								height: 100,
								width: 100,
								filter: 'drop-shadow(0 0 8px rgba(0, 153, 255, 0.3))',
							}}
						/>
					</div>
					<img
						src={selectedCollege?.logo}
						alt='College Logo'
						className='absolute top-[0.88rem] h-[70px] w-[70px] rounded-full 
						 object-cover border-2 border-blue-300 
						 shadow-md transition-transform hover:scale-105'
					/>
				</div>
			</div>

			{/* Profile Completion Section */}
			<div className='mt-auto'>
				<h6 className='text-white text-lg font-semibold mb-2'>Profile Completion</h6>
				<div className='relative'>
					<ProgressBar progress={data?.percentageOfCompletion || 0} title=' ' className='transition-all duration-300 ease-in-out' />
				</div>
			</div>
		</div>
	);
};

export default SecondaryDashboard;
